import React, {useEffect} from 'react';
import MaterialTable, { MTableActions } from "material-table";
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, IconButton} from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { autorun } from 'mobx';
import { observer, useLocalStore } from 'mobx-react-lite';
import { Notification } from '../../../core/Notification';
import { TableStyles } from '../Styles/TableStyles';
import { useStores } from '../../../_stores';
import { IComponent } from '../../../_types/interfaces';
import PatchNotes from '../../PatchNotes/PatchNotes';
import { Description } from '@material-ui/icons';


const Plugins = observer(() => {
    const classes = TableStyles();
    const {componentStore, patchNotesStore} = useStores();

    const materialTableRef = React.createRef<any>();

    const state = useLocalStore(() => ({
        isOpen: false,
    }));

    const {t} = useTranslation();
    const translate = (variable: string) => {
        return t('components.' + variable);
    };

    const OnRowSelect = (props: any) => {
        const update = async () => {
            // убрать выделение
            if (materialTableRef.current)
                materialTableRef.current.onAllSelected(false);
            await componentStore.addComponents((props.data as Array<IComponent>).map(d => d.name));
            const deleteComponents = componentStore.installService.map(m => m.name)
                    .filter(e => !(props.data as Array<IComponent>).map(m => m.name).includes(e))
            if(deleteComponents.length != 0)
                await componentStore.deleteComponents(deleteComponents);
            await componentStore.getAddress();
            await componentStore.loadPlugins();
        }

        return (
            <div className={classes.actions}>
                <Button 
                    startIcon={<SystemUpdateAltIcon/>} 
                    className={classes.update}
                    size={"large"}
                    onClick={async () => await update()}
                >
                    {translate("update")}
                </Button>
            </div>
        );
    };

    useEffect(() => {
        autorun(async () => {
            await componentStore.getAddress();
            await componentStore.loadPlugins();
        });
    }, []);

    return (
        <div>
            {
                componentStore.loading &&
                <div className={classes.loading}> <CircularProgress disableShrink/> </div>
            }
            <MaterialTable
                localization={t('tables', {returnObjects: true})}
                title={translate("titlePlugin")}
                columns={[
                    {field: 'name', title: translate("columns.name")},
                    {field: 'version', title: translate("columns.version")},
                    {field: 'file', title: t('patchNotes.patchNote'), 
                        cellStyle: { width: '10%', }, 
                        render: rowData => (
                        <IconButton 
                            style = {{marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                            onClick = { async () => {
                                await patchNotesStore.loadLocalPatchNotesPlugin(rowData.name);
                                if(patchNotesStore.textPatchNote === "")
                                    await patchNotesStore.loadGlobalPatchNote(rowData.name); 
                                state.isOpen = true;                     
                                }}>
                            <Description/>
                        </IconButton>)
                    },
                ]}
                data={
                componentStore.plugins.map(m => 
                    componentStore.installPlugins.find(f => f.name === m.name)
                    ?  {...m, tableData: {checked: true}}
                    : m
                )}
                options={{
                    search: false,
                    selection: true,
                    paging: false,
                }}
                components={{
                    Actions: props => {
                        // Отрисовка, если есть данные
                        if (props != null)
                            return <OnRowSelect {...props}/>
                        return <MTableActions {...props} /> 
                    },
                }}
                tableRef={materialTableRef}
            />
            <Notification
                isOpen={componentStore.isNotification}
                close={() => componentStore.isNotification = false}
                okClick={() => componentStore.isNotification = false}
                questionText={componentStore.message}
            />
            <PatchNotes
                isOpen={state.isOpen}
                close={() => state.isOpen = false}
            />
        </div>
    )
});

export default Plugins;